export default "__VITE_ASSET__2fFFnK2F__"